<template>
   <div>
      <ddoSelect2 :callbacks="callbacks" ref="mySelect" :options="options">
         <template v-slot:selection="data">
            <v-chip
               v-bind="data.attrs"
               :input-value="data.selected"
            >
               <span v-text="data.item.plf_name"></span>
            </v-chip>
         </template>

         <template v-slot:item="data">
            <v-list-item-content>
               <v-list-item-title v-html="data.item.plf_name"></v-list-item-title>
               <v-list-item-subtitle v-html="data.item.plf_code"></v-list-item-subtitle>
            </v-list-item-content>
         </template>
      </ddoSelect2>
    </div> 
</template>

<script>
import ddoSelect2 from '@/components/ddoSelect2.vue';

export default {
   name: 'ddoSelectPlatform',
   mixins: [ddoSelect2],

   components: {
      ddoSelect2
   },

   async created() {
      console.log("ddoSelectPlatform::created, callbacks="+JSON.stringify(this.callbacks))
      if ( !this.callbacks.refresh_rows ) {
         this.callbacks.refresh_rows = this.build_select_plf;
      }
   },

   async mounted() {
      console.log("ddoSelectPlatform::mounted, callbacks="+JSON.stringify(this.callbacks))
   },

   methods: {

      async build_select_plf(key=null) {
         console.log('build_select_plf, STANDARD');
         this.$emit('loading',true);
         var { errorinfos, api_response } = await this.$api.getRows(this.$router,'platform');
         this.$emit('loading',false);
         return { errorinfos, api_response }
      },
   },

}
</script>